// @flow
import { createContext } from 'react'

/**
 * React Context object, contains the current locale, used for setting the
 * correct language throughout the app.
 * @type {{$$typeof, _calculateChangedBits, _currentValue, _currentValue2,
 *   Provider, Consumer}}
 */
export const LocaleContext: Context<string> = createContext('de')
